import React from 'react';
interface EmailPreviewProps {
  subject: string;
  html: string;
}
export function EmailPreview({
  subject,
  html
}: EmailPreviewProps) {
  return <div className="space-y-4" data-id="element-815">
      <div className="bg-gray-50 p-4 rounded-md border border-gray-200" data-id="element-816">
        <span className="text-sm font-medium text-gray-500" data-id="element-817">Subject:</span>
        <span className="ml-2 text-sm text-gray-900 font-medium" data-id="element-818">
          {subject}
        </span>
      </div>

      <div className="border border-gray-200 rounded-md overflow-hidden" data-id="element-819">
        <div className="bg-gray-100 px-4 py-2 border-b border-gray-200 text-xs text-gray-500 uppercase tracking-wide" data-id="element-820">
          Email Body Preview
        </div>
        <div className="p-8 bg-white min-h-[400px] prose max-w-none" dangerouslySetInnerHTML={{
        __html: html
      }} data-id="element-821" />
      </div>
    </div>;
}